export const NUM_RELATED_JOB_TITLES = 36;
export const NUM_RANDOM_JOB_TITLES = 36;
export const ESTIMATED_NUM_INDUSTRIES = 60;
export const MAX_NUM_INDUSTRIES = 60;
